import { render, staticRenderFns } from "./CollegeProgramme.vue?vue&type=template&id=ce173c7c"
import script from "./CollegeProgramme.vue?vue&type=script&lang=js"
export * from "./CollegeProgramme.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports